import { FormLabels } from 'components/curo-components/forms/types';

export enum IncomeSourcesFields {
  GrossMonthlyIncome = 'grossMonthlyIncome',
  EmploymentType = 'employmentType',
  NextPayDate = 'nextPayDate',
  PaycheckFrequency = 'paycheckFrequency',
  SourceOfIncome = 'sourceOfIncome',
}

export enum EmploymentType {
  Employed = 'Employed',
  SelfEmployed = 'Self Employed',
  Other = 'Other',
}

export enum PaycheckFrequency {
  Weekly = 'Weekly',
  BiWeekly = 'Bi-weekly',
  SemiMonthly = 'Semi-monthly',
  Monthly = 'Monthly',
}

export interface IIncomeSourcesFormValues {
  [IncomeSourcesFields.GrossMonthlyIncome]: number | null;
  [IncomeSourcesFields.EmploymentType]: EmploymentType;
  [IncomeSourcesFields.NextPayDate]: string;
  [IncomeSourcesFields.PaycheckFrequency]: string;
  [IncomeSourcesFields.SourceOfIncome]?: string;
}

export const incomeSourcesFormLabels: FormLabels<IncomeSourcesFields> = {
  [IncomeSourcesFields.EmploymentType]: '',
  [IncomeSourcesFields.GrossMonthlyIncome]: 'Gross Monthly Income',
  [IncomeSourcesFields.NextPayDate]: 'Next Pay Date',
  [IncomeSourcesFields.PaycheckFrequency]: 'Pay Frequency',
  [IncomeSourcesFields.SourceOfIncome]: 'Source of Income',
};
